import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { PlansScreen } from '@/features/plans/plans'
import { type PlansSearch, plansSearchSchema } from '@/features/plans/search'

/**
 * Route shell for the plans & entitlements screen — plan 05 Task 13.
 *
 * The selected group — whose entitlements are on show — lives in the URL as
 * the screen's filter, so a specific customer's view is linkable and survives
 * a reload (AGENTS.md).
 *
 * Per the route-shell rule, this file is a route definition, its search
 * validation and a render. The screen lives in `src/features/plans/`.
 */
export const Route = createFileRoute('/_authenticated/plans')({
  validateSearch: plansSearchSchema,
  component: PlansRoute,
})

function PlansRoute() {
  const navigate = useNavigate()
  const search = Route.useSearch()

  return (
    <PlansScreen
      search={search}
      onSearchChange={(patch: Partial<PlansSearch>) => {
        void navigate({
          to: '/plans',
          search: { ...search, ...patch },
          replace: true,
        })
      }}
    />
  )
}
